import { QueryClient, QueryKey } from '@tanstack/react-query';
import { SaleItemType } from '../../../components/Search/interfaces/product-action.dto';
import { CatalogSectionKit } from '../../../modules/catalogs/products/interfaces/catalogProductList.types';
import { ESProductCatalogSearch } from '../../../modules/catalogs/products/product-catalog-es.types';
import { CATALOG_PRODUCTS_KEY_SEGMENT } from './catalogProducts.keys';

interface PatchKitOrderQuantityInPageParams {
  page: ESProductCatalogSearch[];
  kitId: string;
  orderQuantity: number;
}

interface IsCatalogProductsPageOfOrderParams {
  queryKey: QueryKey;
  orderId: string;
}

interface PatchCatalogKitOrderQuantityParams {
  queryClient: QueryClient;
  orderId: string;
  kitId: string;
  orderQuantity: number;
}

const isTargetKit = (
  item: ESProductCatalogSearch['item'],
  kitId: string,
): item is CatalogSectionKit => item.type === SaleItemType.KIT && item.kitId === kitId;

const isContextParamsSegment = (segment: unknown): segment is { orderId?: string } =>
  typeof segment === 'object' && segment !== null && 'isAdminSeller' in segment;

export const patchKitOrderQuantityInPage = ({
  page,
  kitId,
  orderQuantity,
}: PatchKitOrderQuantityInPageParams): ESProductCatalogSearch[] => {
  if (!page.some((entry) => isTargetKit(entry.item, kitId))) {
    return page;
  }

  return page.map((entry) => {
    if (!isTargetKit(entry.item, kitId)) {
      return entry;
    }

    return { ...entry, item: { ...entry.item, orderQuantity } };
  });
};

export const isCatalogProductsPageOfOrder = ({
  queryKey,
  orderId,
}: IsCatalogProductsPageOfOrderParams): boolean =>
  queryKey.includes(CATALOG_PRODUCTS_KEY_SEGMENT) &&
  queryKey.some((segment) => isContextParamsSegment(segment) && segment.orderId === orderId);

export const patchCatalogKitOrderQuantity = ({
  queryClient,
  orderId,
  kitId,
  orderQuantity,
}: PatchCatalogKitOrderQuantityParams): void => {
  queryClient.setQueriesData<ESProductCatalogSearch[]>(
    { predicate: (query) => isCatalogProductsPageOfOrder({ queryKey: query.queryKey, orderId }) },
    (page) => (page ? patchKitOrderQuantityInPage({ page, kitId, orderQuantity }) : page),
  );
};
